// ** Third Party Components
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

// #####################################################

const StyledContainer = styled.div`
	background: black;
	color: rgba(255, 255, 255, 0.65);
	${({ isEditAvatarComponent }) =>
		isEditAvatarComponent &&
		css`
			background: ${({ theme: { colors } }) => colors.whiteTrue};
			color: ${({ theme: { isDarkMode } }) =>
				isDarkMode ? "rgba(255, 255, 255, 0.65)" : "black"};
		`}

	${({ direction }) =>
		direction === "prev"
			? `left: 0; padding: 5px 10px 15px 0;`
			: `right: 0; padding: 5px 0 15px 10px;`}
	position: absolute;
	z-index: 2;
	top: 0;
	bottom: 0;
	width: 40px;
	height: 100px;
	text-align: center;
`;

const StyledArrow = styled.div`
	cursor: pointer;
	position: relative;
	width: 100%;
	height: 100%;
	font-family: swiper-icons;
	font-weight: 400;
	font-size: 26px;
	line-height: 30px;
	text-align: center;

	&::before {
		${({ direction }) =>
			direction === "prev" ? `left: "50%";` : `right: "50%";`}
		${({ direction }) =>
			direction === "prev" ? `content: "prev";` : `content: "next";`}
		position: absolute;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		-moz-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		-o-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}
`;

// #####################################################

const NavigationArrowThumbnails = ({
	direction,
	swiper,
	thumbnailsPerView,
	getThumbnails,
	setNavArrowClicked,
	isEditAvatarComponent = false,
}) => (
	// #####################################################

	<StyledContainer
		direction={direction}
		isEditAvatarComponent={isEditAvatarComponent}
		onClick={() => {
			if (typeof setNavArrowClicked === "function") {
				setNavArrowClicked(true);
			}
			if (direction === "prev" && swiper.progress > 0) {
				swiper.slideTo(
					swiper.activeIndex - Math.round(thumbnailsPerView) + 2,
					300
				);
				if (typeof getThumbnails === "function") {
					getThumbnails();
				}
			} else if (direction === "next" && swiper.progress < 1) {
				swiper.slideTo(
					swiper.activeIndex + Math.round(thumbnailsPerView) - 2,
					300
				);
				if (typeof getThumbnails === "function") {
					getThumbnails();
				}
			}
		}}
	>
		<StyledArrow direction={direction} />
	</StyledContainer>
);
// #####################################################

NavigationArrowThumbnails.propTypes = {
	direction: PropTypes.oneOf(["next", "prev"]).isRequired,
};

export default NavigationArrowThumbnails;
